import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { ILoginResponse } from 'services/auth/types';
import { teamsAutoLogin } from 'services/auth';

interface IProps {
  userId: string;
  userPrincipal: string;
}

export const ThunkTeamsAutoLogin = createAsyncThunk<ILoginResponse, IProps>(
  `${storeResources.AUTH}/teamsAutoLogin`,
  (payload: IProps) => teamsAutoLogin(payload).then(res => res.data),
);

export default {};
